'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var inputHandler = function inputHandler(inputTypes) {
  return function (props) {
    if (props.type === 'composed') {
      var Composed = inputTypes[props.type];
      return _react2.default.createElement(_reduxForm.Fields, Object.assign({
        names: props.names,
        validate: props.validate,
        key: props.names.join(),
        component: Composed
      }, props));
    }
    if (props.type === 'dynamicPhones') {
      var DynamicPhones = inputTypes[props.type];
      return _react2.default.createElement(DynamicPhones, Object.assign({
        'data-testid': 'DynamicPhones',
        key: props.name
      }, props));
    }
    if (props.type === 'actionButton') {
      var ActionButton = inputTypes[props.type];
      return _react2.default.createElement(ActionButton, Object.assign({
        key: props.name
      }, props));
    }
    var InputComponent = inputTypes[props.type];
    return _react2.default.createElement(_reduxForm.Field, Object.assign({
      key: props.name,
      component: InputComponent,
      required: props.isRequired,
      immutableProps: ['name', 'label']
    }, props));
  };
};
exports.default = inputHandler;